import React, { useState } from "react";
import "../styles/RegisterModal.css";

const RegistrationTrainer = ({ onClose, onRegistrationSuccess }) => {
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    phone: "",
    password: "",
    confirmPassword: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (formData.password !== formData.confirmPassword) {
      alert("Passwords do not match!");
      return;
    }

    // Save formData to backend here (to be implemented later)
    console.log("Trainer Registered:", formData);

    // Directly grant access after successful registration
    onRegistrationSuccess();
  };

  return (
    <div className="register-modal">
      <div className="modal-content">
        <span className="close-btn" onClick={onClose}>
          &times;
        </span>
        <h2>Register to Access Full Playlist</h2>
        <form onSubmit={handleSubmit}>
          <input type="text" name="fullName" placeholder="Full Name" required onChange={handleChange} />
          <input type="email" name="email" placeholder="Email Address" required onChange={handleChange} />
          <input type="text" name="phone" placeholder="Phone Number (optional)" onChange={handleChange} />
          <input type="password" name="password" placeholder="Password" required onChange={handleChange} />
          <input type="password" name="confirmPassword" placeholder="Confirm Password" required onChange={handleChange} />
          <button type="submit">Register</button>
        </form>
      </div>
    </div>
  );
};

export default RegistrationTrainer;
